import { useQuery } from "@tanstack/react-query";
import { getAdminUsersStats } from "services/role-access.service";

export const useAdminStats = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["adminStats"],
    queryFn: getAdminUsersStats,
    select: (res) => res?.data,
  });

  return {
    stats: {
      totalAdminUser: data?.totalAdminUser ?? null,
      totalActiveUsers: data?.totalActiveUsers ?? null,
      totalInviteesPending: data?.totalInviteesPending ?? null,
    },
    isLoading,
    isError,
  };
};
